<mat-form-field class="InputPadrao">
  <mat-label>{{label}}</mat-label>
  <input [type]="showPassword ? 'text' : 'password'" matInput required formControlName="passwordDefinition" maxlength="6"  (onChange)="handleChangeEvent($event)">
  <a (click)="showPassword = !showPassword" class="material-icons showPassword">
     <span *ngIf="showPassword==false">remove_red_eye</span>
     <span *ngIf="showPassword"><span class="material-icons">visibility_off</span></span>
  </a>
</mat-form-field>

<ng-container *ngIf="hint">
  <div class="mb-5 mt-3">
    <mat-hint class="d-flex align-items-center" *ngIf="specialCharacter == 0" [ngStyle]="{'color':specialCharacterValid ? 'green' : 'red'}" >
      <img *ngIf="specialCharacterValid" src="../../../../assets/svg/icon-spinner.svg" alt="spinner" class="icon-label me-2">
      <img *ngIf="!specialCharacterValid" src="../../../../assets/svg/icon-done-green.svg" alt="icon-done-green" class="icon-label me-2">
      <p class="m-0">Use somente letras e números</p>
    </mat-hint>
  </div>
</ng-container>